{
	"submitTitle": "Sélectionner le matériau",
	"summary": {
		"title": "Récapitulatif",
		"declarationTypeTitle": "Type de déclaration",
		"projectReferenceTitle": "Référence du projet"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Sélectionner le type de déclaration",
			"customerProject": {
				"title": "Projet client",
				"description": "Le matériau a été utilisé pour un projet externe. Je dois maintenant fournir une déclaration détaillant les réductions de carbone pour mon client."
			},
			"internalProjectOrProduct": {
				"title": "Projet / produit interne",
				"description": "Le matériau a été utilisé pour un projet ou un produit interne. Je dois créer une déclaration afin de réclamer les réductions de carbone pour nos propres opérations."
			}
		},
		"addProjectReferenceSection": {
			"title": "Ajouter une référence de projet",
			"subTitle": "Vous devez attribuer les réductions de carbone à une référence de projet pour laquelle vous souhaitez créer la déclaration.",
			"projectReferencePlaceholder": "Référence du projet"
		},
		"selectProjectSection": {
			"title": "Sélectionner un projet",
			"createNewProjectPlaceholder": "Créer un nouveau projet"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Le type de déclaration est requis",
		"projectReferenceRequired": "La référence du projet est requise",
		"fetchProjectsError": "Échec de la récupération des projets précédents"
	}
}
